<template>
  <div>
    <div class="my-6 px-6 flex justify-end">
      <vs-button type="relief" icon-pack="feather" icon="icon-printer" @click="printData()">Export</vs-button>
    </div>

    <vx-card>
      <div class="vx-row">
        <div class="vx-col w-3/5 text-center"><p>Akun</p></div>
        <div class="vx-col w-1/5 text-center"><p>Debit</p></div>
        <div class="vx-col w-1/5 text-center"><p>Kredit</p></div>
      </div>
      <vs-divider class=""></vs-divider>
      <div v-for="(neraca, index) in akuns" :key="index">
        <div class="vx-row px-6 py-4" :key="neraca.id">
          <div class="vx-col w-full">
            <h2 class="mb-8"><b>{{ neraca.nomor }}</b> - {{ neraca.name }}</h2>
            
            <div :key="neraca.id">
              <div v-for="(neraca1, index1) in neraca.group" :key="index1">
                  <template v-if="!neraca1.group">
                    <div class="vx-row">
                      <div class="vx-col w-3/5">
                        <span class="text-lg "><b>{{ neraca1.nomor }}</b> - {{ neraca1.name }}</span>
                      </div>
                      <div class="vx-col w-1/5">
                        <div v-if="neraca1.dk === 'debit'" class="flex justify-between">
                          <p>Rp.</p>
                          <h5>{{ formatTotal(neraca1.total) }}</h5>
                        </div>
                      </div>
                      <div class="vx-col w-1/5">
                        <div v-if="neraca1.dk === 'kredit'" class="flex justify-between">
                          <p>Rp.</p>
                          <h5>{{ formatTotal(neraca1.total) }}</h5>
                        </div>
                      </div>
                    </div>
                    <vs-divider class="mt-1"></vs-divider>
                  </template>
                  
                  <template class="mt-2" v-else>
                    <h3 class=" my-8"><b>{{ neraca1.nomor }}</b> - {{ neraca1.name }}</h3>
                    <div v-for="(neraca2, index2) in neraca1.group" :key="index2">
                      <template v-if="!neraca2.group">
                        <div class="vx-row">
                          <div class="vx-col w-3/5">
                            <span class="text-lg "><b>{{ neraca2.nomor }}</b> - {{ neraca2.name }}</span>
                          </div>
                          <div class="vx-col w-1/5">
                            <div v-if="neraca2.dk === 'debit'" class="flex justify-between">
                              <p>Rp.</p>
                              <h5>{{ formatTotal(neraca2.total) }}</h5>
                            </div>
                          </div>
                          <div class="vx-col w-1/5">
                            <div v-if="neraca2.dk === 'kredit'" class="flex justify-between">
                              <p>Rp.</p>
                              <h5>{{ formatTotal(neraca2.total) }}</h5>
                            </div>
                          </div>
                        </div>
                        <vs-divider class="mt-1"></vs-divider>
                      </template>
                      
                      <template v-else>
                        <h4 class=" my-8"><b>{{ neraca2.nomor }}</b> - {{ neraca2.name }}</h4>
                        
                        <div v-for="(neraca3, index3) in neraca2.group" :key="index3" class="vx-row">
                          <div class="vx-col w-3/5">
                            <span class="text-lg"><b>{{ neraca3.nomor }}</b> - {{ neraca3.name }}</span>
                          </div>
                          <div class="vx-col w-1/5">
                            <div v-if="neraca3.dk === 'debit'" class="flex justify-between">
                              <p>Rp.</p>
                              <h5>{{ formatTotal(neraca3.total) }}</h5>
                            </div>
                          </div>
                          <div class="vx-col w-1/5">
                            <div v-if="neraca3.dk === 'kredit'" class="flex justify-between">
                              <p>Rp.</p>
                              <h5>{{ formatTotal(neraca3.total) }}</h5>
                            </div>
                          </div>
                          <vs-divider class="mt-1"></vs-divider>
                        </div>
                      
                      </template>
                      
                    </div>
                  </template>
                  
              </div>
            </div>
            
          </div>
        </div>
      </div>
      <div class="vx-row px-6 py-4">
        <div class="vx-col w-3/5 flex justify-center"><h4>SALDO</h4></div>
        <div class="vx-col w-1/5 text-center flex justify-between">
          <p>Rp.</p>
          <h5>{{ formatTotal(saldo.saldo_debit) }}</h5>
        </div>
        <div class="vx-col w-1/5 text-center flex justify-between">
          <p>Rp.</p>
          <h5>{{ formatTotal(saldo.saldo_kredit) }}</h5>
        </div>
      </div>
    </vx-card>

    <div class="pro-vs-loading px-12" v-if="onPro">
      <vs-progress :percent="onPercent" color="primary" class="mx-8">primary</vs-progress>
    </div>

    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1200"
      filename="M"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @progress="onProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      :htmlToPdfOptions="htmlToPdfOptions"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <section class="pdf-item px-6">
          <div class="text-center mb-10">
            <h3>NERACA SALDO</h3>
            <h3></h3>
            <h3>Tahun  Per </h3>
          </div>
          <vs-divider></vs-divider>
          <div class="vx-row">
            <div class="vx-col w-3/5 text-center"><p>Akun</p></div>
            <div class="vx-col w-1/5 text-center"><p>Debit</p></div>
            <div class="vx-col w-1/5 text-center"><p>Kredit</p></div>
          </div>
          <vs-divider></vs-divider>
          <div v-for="(neraca, index) in akuns" :key="index">
            <div class="vx-row px-6 py-4" :key="neraca.id">
              <div class="vx-col w-full">
                <h2 class="mb-8"><b>{{ neraca.nomor }}</b> - {{ neraca.name }}</h2>
                
                <div :key="neraca.id">
                  <div v-for="(neraca1, index1) in neraca.group" :key="index1">
                      <template v-if="!neraca1.group">
                        <div class="vx-row">
                          <div class="vx-col w-3/5">
                            <span class="text-lg "><b>{{ neraca1.nomor }}</b> - {{ neraca1.name }}</span>
                          </div>
                          <div class="vx-col w-1/5">
                            <div v-if="neraca1.dk === 'debit'" class="flex justify-between">
                              <p>Rp.</p>
                              <h5>{{ formatTotal(neraca1.total) }}</h5>
                            </div>
                          </div>
                          <div class="vx-col w-1/5">
                            <div v-if="neraca1.dk === 'kredit'" class="flex justify-between">
                              <p>Rp.</p>
                              <h5>{{ formatTotal(neraca1.total) }}</h5>
                            </div>
                          </div>
                        </div>
                        <vs-divider class="mt-1"></vs-divider>
                      </template>
                      
                      <template class="mt-2" v-else>
                        <h3 class=" my-8"><b>{{ neraca1.nomor }}</b> - {{ neraca1.name }}</h3>
                        <div v-for="(neraca2, index2) in neraca1.group" :key="index2">
                          <template v-if="!neraca2.group">
                            <div class="vx-row">
                              <div class="vx-col w-3/5">
                                <span class="text-lg "><b>{{ neraca2.nomor }}</b> - {{ neraca2.name }}</span>
                              </div>
                              <div class="vx-col w-1/5">
                                <div v-if="neraca2.dk === 'debit'" class="flex justify-between">
                                  <p>Rp.</p>
                                  <h5>{{ formatTotal(neraca2.total) }}</h5>
                                </div>
                              </div>
                              <div class="vx-col w-1/5">
                                <div v-if="neraca2.dk === 'kredit'" class="flex justify-between">
                                  <p>Rp.</p>
                                  <h5>{{ formatTotal(neraca2.total) }}</h5>
                                </div>
                              </div>
                            </div>
                            <vs-divider class="mt-1"></vs-divider>
                          </template>
                          
                          <template v-else>
                            <h4 class=" my-8"><b>{{ neraca2.nomor }}</b> - {{ neraca2.name }}</h4>
                            
                            <div v-for="(neraca3, index3) in neraca2.group" :key="index3" class="vx-row">
                              <div class="vx-col w-3/5">
                                <span class="text-lg"><b>{{ neraca3.nomor }}</b> - {{ neraca3.name }}</span>
                              </div>
                              <div class="vx-col w-1/5">
                                <div v-if="neraca3.dk === 'debit'" class="flex justify-between">
                                  <p>Rp.</p>
                                  <h5>{{ formatTotal(neraca3.total) }}</h5>
                                </div>
                              </div>
                              <div class="vx-col w-1/5">
                                <div v-if="neraca3.dk === 'kredit'" class="flex justify-between">
                                  <p>Rp.</p>
                                  <h5>{{ formatTotal(neraca3.total) }}</h5>
                                </div>
                              </div>
                              <vs-divider class="mt-1"></vs-divider>
                            </div>
                          
                          </template>
                          
                        </div>
                      </template>
                      
                  </div>
                </div>
                
              </div>
            </div>
          </div>
          <div class="vx-row px-6 py-4">
            <div class="vx-col w-3/5 flex justify-center"><h4>SALDO</h4></div>
            <div class="vx-col w-1/5 text-center flex justify-between">
              <p>Rp.</p>
              <h5>{{ formatTotal(saldo.saldo_debit) }}</h5>
            </div>
            <div class="vx-col w-1/5 text-center flex justify-between">
              <p>Rp.</p>
              <h5>{{ formatTotal(saldo.saldo_kredit) }}</h5>
            </div>
          </div>
        </section>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import moduleNeraca from '@/stores/accounting/neraca/neraca.js'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VueHtml2pdf from 'vue-html2pdf'

export default {
  components: {
    VuePerfectScrollbar,
    VueHtml2pdf
  },
  data () {
    return {
      settings : {
        maxScrollbarLength : 60,
        wheelSpeed         : 0.30
      },
      onPercent: 2,
      onPro: false,
      htmlToPdfOptions: {
        /*
        image: {
          type: 'jpeg', 
          quality: 0.98
        },
        html2canvas: {
          scale: 5,
          useCORS: true
        },
        */
        margin: [10,0,10,0],
        pagebreak: { mode: 'avoid-all', after: '.avoidThisRow' }
      }
    }
  },
  watch: {
  },
  computed: {
    scrollbarTag () { return this.$store.getters.scrollbarTag },

    saldo () { return this.$store.state.neraca.saldo },
    akuns () { return this.$store.state.neraca.tasks },
  },
  created () {
    this.$vs.loading()
    this.$store.registerModule('neraca', moduleNeraca)
    this.$store.dispatch('neraca/fetchNeraca')
    setTimeout(() => {
      this.$vs.loading.close()
    }, 2000)
  },
  beforeUpdate () {
    
  },
  beforeDestroy () {
    this.$store.unregisterModule('neraca')
  },
  mounted () { 
  },
  methods: {
    formatTotal(value) {
      let val = (value/1).toFixed(0).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    onProgress (event) {
      this.onPro = true
      this.onPercent = event
      if (event === 100) {
        this.onPro = false
        this.onPercent = 2
      }
    },
    printData () {
      this.$refs.html2Pdf.generatePdf()
    },
    cekData (data) {
      console.log(data[0].id)
    }
  }
}

</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/buku.scss";
</style>
